export default __webpack_public_path__ + "static/Mask Group 26-62f90bb212235592e520b00469fc9e2e.png";